module.exports = __webpack_public_path__ + "static/media/años1.b1bce878.png";